import React, { useEffect, useState } from "react";
import axios from 'axios';
import Spinner from "../spinner/Spinner";
import PdfReport from "../Pdf/PdfReport";

const CompletedPage = ({ surveyResult, clientData, customerID }) => {

  const [loading, setLoading] = useState(true);
  const [finalResults, setFinalResults] = useState(null);

  useEffect(() => {
    axios.post(process.env.REACT_APP_BACKEND, { ...surveyResult, ...clientData })
      .then(data => {
        setFinalResults(data.data);
        setLoading(false);
      })
      .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    if (finalResults?.bars && /^[0-9]+$/.test(customerID.replace("fitcheck/", ""))) {

      axios.post("https://prod.mypegasus.greple.ai/api/greple-ai/big5",
        { results: finalResults?.bars, customerId: +customerID.replace("fitcheck/", "") }, {
        headers: { Authorization: `Bearer ${process.env.REACT_APP_MYP_TOKEN}` }
      })
        .then(data => {
          console.log("Results Saved to customer's profile in MYP");
        })
        .catch(err => console.log(err));
    }

  }, [finalResults]);


  if (surveyResult === '') {
    window.location.href = "/";
  }

  return loading ? <Spinner /> : <PdfReport finalResults={finalResults} />
}

export default CompletedPage;